export default function CustomerInsights({ study }) {
  const name = study.quoteBy || study.customer;
  const role = study.quoteRole || study.attribution || '';

  return (
    <section className="border-b border-border">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">Customer insights</h2>

        <figure className="mt-4 overflow-hidden rounded-[28px] border border-[hsl(158_28%_82%)] bg-card shadow-sm">
          <div className="px-6 py-7 sm:px-10 sm:py-8 lg:px-12 lg:py-9">
            <blockquote className="mx-auto max-w-5xl text-center text-base font-normal italic leading-relaxed text-foreground sm:text-lg lg:text-xl">
              &ldquo;{study.quote}&rdquo;
            </blockquote>
          </div>

          <figcaption className="border-t border-[hsl(158_28%_86%)] bg-[hsl(158_42%_96%)]">
            <div className="px-6 py-4 sm:px-10 lg:px-12">
              <p className="text-sm font-bold text-foreground">{name}</p>
              {role ? <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{role}</p> : null}
            </div>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
